import { graphql } from "gql.tada";
import { LinkFragment } from "../fragments/LinkFragment";

export const GetStartedRoutingSectionById = graphql(
  /* GraphQL */ `
    query GetStartedRoutingSectionById(
      $locale: String
      $preview: Boolean
      $id: String!
    ) {
      getStartedRoutingSection(id: $id, preview: $preview, locale: $locale) {
        ...GetStartedRoutingSectionFragment
      }
    }
    fragment GetStartedRoutingSectionFragment on GetStartedRoutingSection {
      sys {
        id
      }
      isVertical
      getStartedRoutingTitle: title {
        json
      }
      getStartedRoutingCta: cta {
        ...LinkFragment
      }
      getStartedRoutingBackgroundImage: backgroundImage {
        url
        title
      }
    }
  `,
  [LinkFragment]
);
